<!--component html goes here -->
<div style="height: 100%;text-align: center;">
    <img src="../assets/images/pagenotfound.gif" style="max-width:800px;width:100%;max-height:600px;" alt="Oops!! Page Not Found.">
</div>